(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-promo-band"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('styleware-product-promo')) {
    customElements.define('styleware-product-promo', class extends HTMLElement {
      connectedCallback() {
        // Wait for this section's children to finish parsing.
        queueMicrotask(() => {
          if (!this.isConnected || this.observer) return;
          this.band = this.querySelector('[id^="ProductPromoBand-"]');
          if (!this.band || this.dataset.placement !== 'details') return;

          this.placeBand = () => {
            const target = document.querySelector(
              '.shopify-section--main-product .product-info'
            );
            if (target) {
              if (this.band.parentElement !== target) {
                target.prepend(this.band);
              }
            } else if (this.band.parentElement !== this) {
              // Fall back to the section position if the main product is removed.
              this.append(this.band);
            }
          };

          // Retain the band when Prestige or the editor replaces the main product.
          this.observer = new MutationObserver(this.placeBand);
          this.observer.observe(document.body, { childList: true, subtree: true });
          this.placeBand();
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        // Return the band to its owner for section removal or editor reordering.
        if (this.band && !this.contains(this.band)) this.append(this.band);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
